import { useCallback } from 'react'
import { useAppLanguage } from './useAppLanguage'

export const useLocalizedFormatters = () => {
  const { currentLocale } = useAppLanguage()

  const formatCurrency = useCallback((value, currency = 'USD') => (
    new Intl.NumberFormat(currentLocale, { style: 'currency', currency }).format(Number(value) || 0)
  ), [currentLocale])

  const formatDate = useCallback((value, options = { year: 'numeric', month: 'short', day: 'numeric' }) => (
    new Intl.DateTimeFormat(currentLocale, options).format(new Date(value))
  ), [currentLocale])

  return { currentLocale, formatCurrency, formatDate }
}
